import type { InventoryReportType, InventoryUploadMode } from 'contracts/inventory-2/uploads';

export const INVENTORY_UPLOAD_TYPE_OPTIONS: Array<{
  value: InventoryReportType;
  name: string;
}> = [
  { value: 'classification', name: 'Classificação' },
  { value: 'movements', name: 'Movimentação' },
  { value: 'bom', name: 'BOM' },
  { value: 'toller', name: 'Toller' },
  { value: 'fdr', name: 'Plano FdR' },
  { value: 'rrr', name: 'RRR' },
  { value: 'rccp', name: 'RCCP' },
];

export const XLSX_ONLY_UPLOAD_TYPES: InventoryReportType[] = ['toller', 'fdr', 'rccp'];

export const INVENTORY_UPLOAD_MODE_LABEL: Record<InventoryUploadMode, string> = {
  replace: 'Substituição da tabela',
  cycle: 'Somente os ciclos do arquivo',
  period: 'Somente o intervalo de datas',
};

export const CLASSIFICATION_LABEL: Record<string, string> = {
  PACKAGING: 'Embalagem',
  RAW: 'Matéria-prima',
  FINISHED: 'Produto acabado',
  ATIVO: 'Ativo',
  UNKNOWN: 'Outros',
};

export const MAX_INVENTORY_UPLOAD_SIZE = 50 * 1024 * 1024;
